import * as React from 'react';
import * as PropTypes from 'prop-types';
import {
  Wrapper,
  Loading,
  ButtonIcon
} from './styled';

interface Props {
  children?: React.ReactNode;
  primary?: boolean;
  width?: string;
  fullWidth?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onClick?: Function;
  icon?: string;
  iconPos?: string;
  dataTest?: string;
}

export const Button: React.FC<Props> = ({
  children,
  loading,
  icon,
  dataTest,
  ...nextProps
}) => {
  if(loading) {
    return(
      <Wrapper loading={loading ? 1 : 0} data-test={dataTest} {...nextProps}>
        <Loading {...nextProps} />
      </Wrapper>
    );
  }

  return(
    <Wrapper data-test={dataTest} {...nextProps}>
      { icon && <ButtonIcon name={icon} /> }
      {children}
    </Wrapper>
  )
};

Button.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.bool,
  width: PropTypes.string,
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  iconPos: PropTypes.string,
  dataTest: PropTypes.string,
};

Button.displayName = 'Button';

